import React from 'react';
import Anime from 'react-anime';
import { isBrowser, isMobile } from 'react-device-detect';
import {
  getRandomRadius,
  isEvenNumber
} from './_utils';
import './EndPhaseFour.scss';
import photo from '../assets/elements/img/chapter-33-image-01.png';
import photo2 from '../assets/elements/img/chapter-33-image-02.png';
export default ({ isActive }) => {

  const circlesList = [
    {},{},{}, // 10
  ];
  const mainCircles = [
    {},{}, // 10
  ];
  const randomPos = [
    ['25vw', '5vh'],
    ['65vw', '25vh'],
    ['2vw', '75vh'],
  ]
  const animateCircles = {
    top: [
      { value: (el, i) => {
        return randomPos[i][1];
      }, easing: 'easeInOutElastic', duration: 0}
    ],
    left: [
      { value: (el, i) => {
        return randomPos[i][0];
      } , easing: 'easeInOutElastic', duration: 0}
    ],
    opacity: [
      { value: 0, duration: 0, },
      { value: 1, duration: 500, easing: 'linear'}
    ],
    delay: 3000
  };

  const animateCircles2 = {
    top: [
      {
        value: (el, i) => isEvenNumber(i) ? `59%` : `10%`,
        duration: 0,
      }
    ],
    left: [
      { value: (el, i) => isEvenNumber(i) ? `55%` : `15%`,  duration: 0,}
    ],
    opacity: [
      { value: 0, duration: 0, },
      { value: 1, duration: 500,  easing: 'linear'}
    ],
    delay: 2000
  };

  const dimBackground = {
  }

  const growBalls = {
    width: [
      { value: () => {
        return 150;
      }, duration: 0, }
    ],
    height: [
      { value: () => {
        return 150;
      }, duration: 0, }
    ],
  }

  const scaleBallOuter = {
    scale: [
      { value: 0.1, duration: 0 },
      { value: 1, duration: 1000, easing: 'linear', delay: 2000}
    ]
  }
  const CreateCircles = () => (
    <div className="random-circles">
      <div className="circle-container">
        <Anime {...animateCircles}>
          {circlesList && circlesList.map((circle, i) => {
            let max = isBrowser ? 120 : 100;
            let radius = getRandomRadius(max);
            return (
              <div key={`${i}-1`}
                className={`circle-cover circle-cover-${i}`}>
                <div style={{width: radius[0], height: radius[0]}}></div>
              </div>
            );
          })}
        </Anime>
        <Anime {...animateCircles2}>
          {mainCircles && mainCircles.map((circle, i) => {
            let radius = isEvenNumber(i) && !isMobile ? [400, 400] : [200, 200];
            let bgPhoto = isEvenNumber(i) ? photo : photo2;
            return (
              <Anime {...scaleBallOuter} key={`${i}-1`}
                className={`circle-cover circle-cover-${i}`}>
                <div style={{width: radius[0], height: radius[0]}} >
                  <Anime {...dimBackground}>
                    <div className="image-container"
                      style={{backgroundImage: `url(${bgPhoto})`}}></div>
                  </Anime>
                </div>
              </Anime>
            );
          })}
        </Anime>
      </div>
    </div>
  );
  return (
    <div className="end-phase-four">
      {isActive && (
        <>
          <Anime {...growBalls}></Anime>
          <CreateCircles />
        </>
      )}
    </div>
  );
}